var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("网站信息管理")]),
            ]),
            _vm.name == "guide"
              ? _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { path: "/jcGuide" } } },
                  [_c("div", { staticClass: "div3" }, [_vm._v("渠道客户导入")])]
                )
              : _vm._e(),
            _vm.name == "unab"
              ? _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { path: "/unabsorbed" } } },
                  [_c("div", { staticClass: "div3" }, [_vm._v("未分配客户")])]
                )
              : _vm._e(),
            _vm.name == "assign"
              ? _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { path: "/AssignedCustomers" } } },
                  [_c("div", { staticClass: "div3" }, [_vm._v("已分配客户")])]
                )
              : _vm._e(),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("订单查看")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "address" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("查看订单资料")]),
        _vm._l(_vm.detail, function (items) {
          return _c("div", { key: items.id, staticClass: "box" }, [
            _c("p", [_vm._v("姓名: " + _vm._s(items.orderUser.customerName))]),
            _c("p", [_vm._v("电话: " + _vm._s(items.orderUser.customerPhone))]),
            _c("p", [_vm._v("地区: " + _vm._s(items.orderUser.address))]),
            _c("p", [
              _vm._v("资源时间: " + _vm._s(items.orderUser.createdTime)),
            ]),
            _c(
              "div",
              { staticClass: "goods" },
              [
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v("商品:"),
                ]),
                _vm._l(items.orderCommodityList, function (goodsItems) {
                  return _c("div", { key: goodsItems.id }, [
                    _vm._v(
                      " " +
                        _vm._s(goodsItems.name) +
                        " " +
                        _vm._s(goodsItems.number) +
                        " * ￥" +
                        _vm._s(goodsItems.price) +
                        " = " +
                        _vm._s(goodsItems.total) +
                        " (元) "
                    ),
                  ])
                }),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "goods" },
              [
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v("附属品:"),
                ]),
                _vm._l(items.orderComplimentaryList, function (goodsItems) {
                  return _c("div", { key: goodsItems.id }, [
                    _vm._v(
                      " " +
                        _vm._s(goodsItems.complimentaryName) +
                        " " +
                        _vm._s(goodsItems.number) +
                        " * ￥" +
                        _vm._s(goodsItems.price) +
                        " = " +
                        _vm._s(goodsItems.total) +
                        " (元) "
                    ),
                  ])
                }),
              ],
              2
            ),
            _c("p", [
              _vm._v("产品数量:" + _vm._s(items.orderUser.pieceNumber)),
            ]),
            _c("p", [_vm._v("订单状态: " + _vm._s(items.orderUser.orderType))]),
            items.orderUser.comment
              ? _c("p", [_vm._v("留言:" + _vm._s(items.orderUser.remark))])
              : _c("p", [_vm._v("留言:无")]),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }